import { booleanAttribute, Directive, effect, inject, input } from '@angular/core';

import {
  ImageLoaderDirective as PuImageLoaderDirective,
} from '@hglobal/common';
import { environment } from '@pt/environment';

/**
 * Manual input propagation to inner directive:
 *
 * Angular's `hostDirectives` does not automatically forward input changes
 * from the host component to the inner directive after initial binding.
 *
 * This wrapper uses `ngOnChanges()` to manually propagate changes to the
 * inner `PuImageLoaderDirective` whenever input values update.
 *
 * Without this, dynamic changes to `src`, `skipSmall`, or `optimizationEnabled`
 * on the host would not reflect in the inner directive at runtime.
 */
@Directive({
  selector: '[ptImageLoader]',
  standalone: true,
  hostDirectives: [
    {
      directive: PuImageLoaderDirective,
    },
  ],
})
export class ImageLoaderDirective {
  src = input<string | undefined>();
  skipSmall = input(false, { transform: booleanAttribute });
  optimizationEnabled = input(environment.imagesOptimizationEnabled, {
    transform: booleanAttribute,
  });

  #innerDirective = inject(PuImageLoaderDirective);

  constructor() {
    effect(() => {
      const inner = this.#innerDirective;
      if (!inner) return;

      inner.puImageLoader = this.src();
      inner.skipSmall = this.skipSmall();
      inner.optimizationEnabled = this.optimizationEnabled();
    });
  }
}
